export var ToastUtils;
(function (ToastUtils) {
    ToastUtils.POSITIONS = [
        "bottom-center",
        "bottom-left",
        "bottom-right",
        "top-center",
        "top-left",
        "top-right"
    ];
})(ToastUtils || (ToastUtils = {}));
